import { type Api } from "api-client";
import { Icon } from "icons";
import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  type ButtonVariant,
  Dialog,
  DialogContent,
  DialogTrigger,
  type ButtonSize,
} from "ui";

import { InviteAthleteDialogContent } from "src/components/InviteAthleteDialogContent";

export { InviteAthleteDialogContent };
export { formSchema } from "src/invitations/InviteAthleteDialog.shared";
export type {
  FormSchema,
  InviteAthleteDialogContentProps,
} from "src/invitations/InviteAthleteDialog.shared";

export interface InviteAthleteDialogProps {
  refresh?: () => void;
  buttonVariant?: ButtonVariant;
  buttonSize?: ButtonSize;
  buttonClassName?: string;
  onInviteSuccess?: (arg: Api.InviteAthlete.Output.Self) => void;
  showTrigger?: boolean;
  open?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  name?: string;
}

export function InviteAthleteDialog(props: InviteAthleteDialogProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const showTrigger = props.showTrigger ?? true;
  const { t } = useTranslation();

  const open = props.open ?? isOpen;
  const onOpenChange = props.onOpenChange ?? setIsOpen;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {showTrigger && (
        <DialogTrigger asChild>
          <Button
            className={props.buttonClassName}
            size={props.buttonSize}
            variant={props.buttonVariant}
          >
            <Icon name="tabler-plus" />
            {t("inviteAthlete.trigger")}
          </Button>
        </DialogTrigger>
      )}
      <DialogContent className="sm:max-w-[425px]">
        {open && (
          <InviteAthleteDialogContent
            name={props.name}
            closeModal={() => {
              onOpenChange(false);
              props.refresh?.();
            }}
            onInviteSuccess={props.onInviteSuccess}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
